import React, { useEffect, useState } from 'react';

export const PositionImportDialog = ({ currentFen, onCancel, onImport }) => {
  const [fen, setFen] = useState(currentFen);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const result = onImport(fen);
    if (!result.ok) setError(result.error);
  };

  return (
    <div className="position-dialog-backdrop" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onCancel();
    }}>
      <section className="position-dialog" role="dialog" aria-modal="true" aria-labelledby="position-dialog-title">
        <span className="position-dialog__eyebrow">Position setup</span>
        <h2 id="position-dialog-title">Import a FEN position</h2>
        <p>Paste a standard FEN string. This replaces the board and starts a fresh game record from that position.</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="fen-position">FEN</label>
          <textarea
            id="fen-position"
            value={fen}
            onChange={(event) => {
              setFen(event.target.value);
              setError('');
            }}
            rows="4"
            spellCheck="false"
            autoFocus
          />
          {error && <p className="position-dialog__error" role="alert">{error}</p>}
          <div className="position-dialog__actions">
            <button type="button" className="secondary-action" onClick={onCancel}>Cancel</button>
            <button type="submit" className="primary-action">Load position</button>
          </div>
        </form>
      </section>
    </div>
  );
};

const PositionTools = ({ onExportPgn, onOpenImport }) => {
  const [exported, setExported] = useState(false);

  const handleExport = () => {
    onExportPgn();
    setExported(true);
    window.setTimeout(() => setExported(false), 1800);
  };

  return (
    <section className="position-tools" aria-labelledby="position-tools-title">
      <div className="section-heading">
        <h2 id="position-tools-title">Game tools</h2>
        <span aria-live="polite">{exported ? 'PGN downloaded' : 'PGN · FEN'}</span>
      </div>
      <div className="position-tools__actions">
        <button type="button" onClick={handleExport}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12m0 0 4-4m-4 4-4-4M5 18v3h14v-3" /></svg>
          Export PGN
        </button>
        <button type="button" onClick={onOpenImport}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21V9m0 0 4 4m-4-4-4 4M5 6V3h14v3" /></svg>
          Import FEN
        </button>
      </div>
    </section>
  );
};

export default PositionTools;
